/**
 * GENERATED FILE - DO NOT MODIFY
 */

export const accordionItemBorderColor = "#d4d4d4";
export const accordionItemBorderWidthBottom = "1px";
export const accordionTriggerFontSize = "16px";
export const accordionTriggerLineHeight = "24px";
export const accordionTriggerFontWeight = "500";
export const accordionTriggerSpacePaddingY = "16px";
export const accordionTriggerIconColor = "#262626";
export const accordionTriggerIconSize = "24px";
export const accordionContentFontSize = "14px";
export const accordionContentLineHeight = "20px";
export const accordionContentSpacePaddingT = "0px";
export const accordionContentSpacePaddingB = "16px";
export const accordionKeyframesAccordionDownFrom = { height: "0" };
export const accordionKeyframesAccordionDownTo = {
  height: "var(--radix-accordion-content-height)",
};
export const accordionKeyframesAccordionUpFrom = {
  height: "var(--radix-accordion-content-height)",
};
export const accordionKeyframesAccordionUpTo = { height: "0" };
export const accordionAnimationAccordionDown =
  "accordion-keyframes-accordion-down 0.2s ease-out";
export const accordionAnimationAccordionUp =
  "accordion-keyframes-accordion-up 0.2s ease-out";
export const alertDialogOverlayColorBackground = "#000000";
export const alertDialogOverlayOpacityBackground = "0.8";
export const alertDialogContentColorBackground = "#ffffff";
export const alertDialogContentShadow =
  "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)";
export const alertDialogContentSpaceGap = "16px";
export const alertDialogContentSpacePadding = "24px";
export const alertDialogContentRadius = "4px";
export const alertDialogContentBorderWidth = "1px";
export const alertDialogHeaderSpaceMarginY = "8px";
export const alertDialogFooterSpaceMarginX = "8px";
export const alertDialogTitleSize = "18px";
export const alertDialogTitleColor = "#0058a9";
export const alertDialogTitleFontWeight = "600";
export const alertDialogTitleLineHeight = "28px";
export const alertDialogDescriptionColor = "#737373";
export const alertDialogDescriptionSize = "14px";
export const alertDialogDescriptionLineHeight = "20px";
export const alertDialogCancelSpaceMarginTDefault = "0px";
export const alertDialogCancelSpaceMarginTDesktop = "8px";
export const alertColorBackgroundDefault = "#ffffff";
export const alertColorBackgroundInfo = "#eff6ff";
export const alertColorBackgroundSuccess = "#f0fdf4";
export const alertColorBackgroundWarning = "#fffbeb";
export const alertColorBackgroundError = "#fef2f2";
export const alertColorBorderDefault = "#e5e5e5";
export const alertColorBorderInfo = "#bfdbfe";
export const alertColorBorderSuccess = "#bbf7d0";
export const alertColorBorderWarning = "#fde68a";
export const alertColorBorderError = "#fecaca";
export const alertColorBorderDestructive = "#dc2626";
export const alertColorIconDefault = "#525252";
export const alertColorIconInfo = "#1d4ed8";
export const alertColorIconSuccess = "#15803d";
export const alertColorIconWarning = "#b45309";
export const alertColorIconError = "#b91c1c";
export const alertColorIconDestructive = "#dc2626";
export const alertColorTitleDefault = "#262626";
export const alertColorTitleInfo = "#1e3a8a";
export const alertColorTitleSuccess = "#14532d";
export const alertColorTitleWarning = "#78350f";
export const alertColorTitleError = "#7f1d1d";
export const alertColorTitleDestructive = "#dc2626";
export const alertColorTextDefault = "#262626";
export const alertColorTextInfo = "#1e3a8a";
export const alertColorTextSuccess = "#14532d";
export const alertColorTextWarning = "#78350f";
export const alertColorTextError = "#7f1d1d";
export const alertColorTextDestructive = "#dc2626";
export const alertSpacePadding = "16px";
export const alertSpacePaddingL = "28px";
export const alertBorderWidth = "1px";
export const alertRadius = "4px";
export const alertTitleFontFamily = ["Inter Variable", "sans-serif"];
export const alertTitleFontSize = "16px";
export const alertTitleFontWeight = "500";
export const alertTitleLineHeight = "1";
export const alertTitleLetterSpacing = "-0.025em";
export const alertTitleSpaceMarginB = "4px";
export const alertDescriptionFontSize = "14px";
export const alertDescriptionLineHeight = "1.5";
export const alertIconFontSize = "18px";
export const alertIconSpaceLeft = "16px";
export const alertIconSpaceTop = "16px";
export const alertIconSpaceTranslateMinY = "-0px";
export const breadcrumbColorTextDefault = "#737373";
export const breadcrumbColorTextHover = "#262626";
export const breadcrumbColorTextActive = "#262626";
export const breadcrumbListFontSize = "14px";
export const breadcrumbListSpaceGap = "6px";
export const breadcrumbItemSpaceGap = "6px";
export const breadcrumbPageFontWeight = "400";
export const breadcrumbSeparatorColor = "#737373";
export const breadcrumbSeparatorSize = "14px";
export const breadcrumbEllipsisColor = "#737373";
export const breadcrumbEllipsisSizeDefault = "36px";
export const breadcrumbEllipsisSizeIcon = "16px";
export const actionButtonBorderWidthEnabled = "1px";
export const actionButtonBorderWidthFocus = "2px";
export const actionButtonBorderWidthOutline = "1px";
export const actionButtonColorBackgroundDangerEnabled = "#dc2626";
export const actionButtonColorBackgroundDangerHover = "#b91c1c";
export const actionButtonColorBackgroundDefaultEnabled = "#ffffff";
export const actionButtonColorBackgroundDefaultHover = "#f5f5f5";
export const actionButtonColorBackgroundGhostHover = "#f5f5f5";
export const actionButtonColorBackgroundPrimaryEnabled = "#015094";
export const actionButtonColorBackgroundPrimaryHover = "#006fd0";
export const actionButtonColorBackgroundSecondaryEnabled = "#f5f5f5";
export const actionButtonColorBackgroundSecondaryHover = "#e5e5e5";
export const actionButtonColorBackgroundOutlineEnabled = "#ffffff";
export const actionButtonColorBackgroundOutlineHover = "#f5f5f5";
export const actionButtonColorBorderDangerEnabled = "#dc2626";
export const actionButtonColorBorderDangerFocus = "#2563eb";
export const actionButtonColorBorderDangerHover = "#b91c1c";
export const actionButtonColorBorderDefaultEnabled = "#d4d4d4";
export const actionButtonColorBorderDefaultFocus = "#2563eb";
export const actionButtonColorBorderDefaultHover = "#d4d4d4";
export const actionButtonColorBorderGhostFocus = "#2563eb";
export const actionButtonColorBorderGhostHover = "#d4d4d4";
export const actionButtonColorBorderPrimaryEnabled = "#d4d4d4";
export const actionButtonColorBorderPrimaryFocus = "#2563eb";
export const actionButtonColorBorderPrimaryHover = "#006fd0";
export const actionButtonColorBorderSecondaryEnabled = "#f5f5f5";
export const actionButtonColorBorderSecondaryFocus = "#2563eb";
export const actionButtonColorBorderSecondaryHover = "#e5e5e5";
export const actionButtonColorBorderOutlineEnabled = "#e5e5e5";
export const actionButtonColorBorderOutlineFocus = "#2563eb";
export const actionButtonColorBorderOutlineHover = "#006fd0";
export const actionButtonColorIconDanger = "#fafafa";
export const actionButtonColorIconDefault = "#262626";
export const actionButtonColorIconPrimary = "#fafafa";
export const actionButtonColorIconSecondary = "#0a0a0a";
export const actionButtonColorTextDanger = "#fafafa";
export const actionButtonColorTextDefault = "#0a0a0a";
export const actionButtonColorTextPrimary = "#fafafa";
export const actionButtonColorTextSecondary = "#0a0a0a";
export const actionButtonFontFamily = ["Inter Variable", "sans-serif"];
export const actionButtonFontSizeLg = "16px";
export const actionButtonFontSizeMd = "16px";
export const actionButtonFontSizeSm = "14px";
export const actionButtonFontWeight = "500";
export const actionButtonLineHeight = "1";
export const actionButtonRadiusDefault = "8px";
export const actionButtonRadiusIconButton = "8px";
export const actionButtonShadowEnabled = "none";
export const actionButtonSizeHeightLg = "40px";
export const actionButtonSizeHeightMd = "36px";
export const actionButtonSizeHeightSm = "32px";
export const actionButtonSizeIconMd = "36px";
export const actionButtonSpaceGapMd = "4px";
export const actionButtonSpacePaddingLg = "32px";
export const actionButtonSpacePaddingMd = "16px";
export const actionButtonSpacePaddingSm = "12px";
export const actionButtonTransition =
  "color 0.2s cubic-bezier(0.22, 1, 0.36, 1), background-color 0.2s cubic-bezier(0.22, 1, 0.36, 1), border-color 0.2s cubic-bezier(0.22, 1, 0.36, 1)";
export const calendarSpacePadding = "12px";
export const calendarNavButtonPositionLeft = "4px";
export const calendarNavButtonPositionRight = "4px";
export const calendarNavButtonSizeWidth = "28px";
export const calendarNavButtonSizeHeight = "28px";
export const calendarNavButtonOpacityDefault = "0.5";
export const calendarNavButtonOpacityHover = "1";
export const calendarNavButtonIconSize = "16px";
export const calendarCaptionSpacePaddingTop = "4px";
export const calendarCaptionLabelFontSize = "14px";
export const calendarCaptionLabelLineHeight = "20px";
export const calendarCaptionLabelFontWeight = "500";
export const calendarDayColorBackgroundSelectedDefault = "#015094";
export const calendarDayColorBackgroundSelectedOutside = "#e5e5e5";
export const calendarDayColorBackgroundToday = "#e5e5e5";
export const calendarDayColorBackgroundRangeMiddle = "#f5f5f5";
export const calendarDayColorTextToday = "#262626";
export const calendarDayColorTextDisabled = "#737373";
export const calendarDayColorTextSelected = "#fafafa";
export const calendarDayColorTextOutsideDefault = "#737373";
export const calendarDayColorTextOutsideSelected = "#737373";
export const calendarDayColorTextRangeMiddle = "#262626";
export const calendarDayRadius = "8px";
export const calendarDayFontSize = "14px";
export const calendarDayLineHeight = "20px";
export const calendarDaySizeWidth = "36px";
export const calendarDaySizeHeight = "36px";
export const calendarDaySpacePadding = "0px";
export const calendarDayOpacityDisabled = "0.5";
export const calendarDayOpacityOutsideDefault = "0.5";
export const calendarDayOpacityOutsideSelected = "0.3";
export const calendarDayButtonFontWeight = "400";
export const calendarDayButtonSizeWidth = "36px";
export const calendarDayButtonSizeHeight = "36px";
export const calendarDayButtonSpacePadding = "0px";
export const calendarDayButtonOpacity = "1";
export const calendarWeekdaysSpacePaddingX = "6px";
export const calendarWeekdayColorText = "#737373";
export const calendarWeekdayRadius = "4px";
export const calendarWeekdaySizeWidth = "36px";
export const calendarWeekdayFontWeight = "400";
export const calendarWeekdayFontSize = "14px";
export const calendarWeekSpaceMarginT = "8px";
export const calendarWeeksSpaceGap = "4px";
export const calendarMonthSpaceMarginDefault = "16px";
export const calendarMonthSpaceMarginNone = "0px";
export const calendarMonthGridSpaceMargin = "4px";
export const calendarMonthsSpaceGap = "16px";
export const cardColorBackground = "#ffffff";
export const cardColorBorder = "#d4d4d4";
export const cardColorText = "#262626";
export const cardBorderWidth = "1px";
export const cardShadow = "0 1px 2px 0 rgb(0 0 0 / 0.05)";
export const cardRadius = "4px";
export const cardTitleFontFamily = ["Inter Variable", "sans-serif"];
export const cardTitleFontSize = "24px";
export const cardTitleFontWeight = "600";
export const cardTitleLineHeight = "1";
export const cardTitleLetterSpacing = "-0.025em";
export const cardTitleColor = "#171717";
export const cardDescriptionFontFamily = ["Inter Variable", "sans-serif"];
export const cardDescriptionFontSize = "14px";
export const cardDescriptionLineHeight = "20px";
export const cardDescriptionColor = "#737373";
export const cardHeaderSpacePadding = "24px";
export const cardHeaderSpaceMarginY = "6px";
export const cardContentSpacePadding = "24px";
export const cardContentSpacePaddingTop = "0px";
export const cardFooterSpacePadding = "24px";
export const cardFooterSpacePaddingTop = "0px";
export const carouselArrowLeftBorderColor = "#d4d4d4";
export const carouselArrowLeftBorderWidth = "1px";
export const carouselNavigationRadius = "4px";
export const carouselNavigationBackground = "#ffffff";
export const carouselNavigationSpacePadding = "0px";
export const carouselNavigationButtonRadius = "4px";
export const carouselNavigationButtonSpacePadding = "0px";
export const carouselNavigationButtonActiveBackground = "#e5e5e5";
export const carouselNavigationButtonActiveColor = "#262626";
export const checkboxBoxBorderWidthDefault = "1px";
export const checkboxBoxColorBackgroundChecked = "#015094";
export const checkboxBoxColorBackgroundDefault = "#ffffff";
export const checkboxBoxColorBorderDefaultEnabled = "#d4d4d4";
export const checkboxBoxColorBorderDefaultChecked = "#015094";
export const checkboxBoxColorBorderDefaultFocus = "#2563eb";
export const checkboxBoxColorBorderDefaultHover = "#015094";
export const checkboxBoxColorIconCheckedEnabled = "#fafafa";
export const checkboxBoxColorRingRing = "#015094";
export const checkboxBoxColorRingOffsetBackground = "#ffffff";
export const checkboxBoxRadius = "4px";
export const checkboxBoxSizeHeight = "16px";
export const checkboxBoxSizeWidth = "16px";
export const checkboxBoxRingFocusWidth = "2px";
export const checkboxBoxRingFocusOffset = "2px";
export const checkboxBoxOpacityDisabled = "0.5";
export const checkboxIndicatorIcon = "14px";
export const comboboxTriggerColorBorder = "#d4d4d4";
export const comboboxTriggerRadiusDefault = "8px";
export const comboboxTriggerSpacePaddingX = "24px";
export const comboboxValueholderHeight = "14px";
export const comboboxClearableRight = "40px";
export const comboboxClearableMlTrigger = "32px";
export const comboboxColorPlaceholder = "#737373";
export const comboboxFontWeight = "400";
export const comboboxFontSize = "14px";
export const comboboxFontFamily = ["Inter Variable", "sans-serif"];
export const comboboxSpacePaddingL = "12px";
export const comboboxSizeWidth = "240px";
export const comboboxIconSize = "16px";
export const comboboxIconOpacity = "0.5";
export const comboboxPopoverSpacePadding = "0px";
export const commandColorBackground = "#ffffff";
export const commandColorText = "#262626";
export const commandSizeHeight = "100%";
export const commandSizeWidth = "100%";
export const commandDialogSpacePaddingContent = "0px";
export const commandDialogSpacePaddingYGroup = "0px";
export const commandDialogSpacePaddingYItem = "12px";
export const commandDialogSpacePaddingXGroup = "8px";
export const commandDialogSpacePaddingXItem = "8px";
export const commandDialogSizeInputHeight = "48px";
export const commandDialogSizeIcon = "20px";
export const commandDialogShadow =
  "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)";
export const commandInputRadius = "4px";
export const commandInputBorder = "1px";
export const commandInputSizeHeight = "44px";
export const commandInputSizeWidth = "100%";
export const commandInputSizeIcon = "16px";
export const commandInputFontSize = "14px";
export const commandInputLineHeight = "20px";
export const commandInputColorBackground = "rgba(0, 0, 0, 0)";
export const commandInputColorTextPlaceholder = "#737373";
export const commandInputSpacePaddingX = "12px";
export const commandInputSpacePaddingY = "12px";
export const commandInputSpaceIconMargin = "8px";
export const commandInputOpacityIcon = "0.5";
export const commandInputOpacityDisabled = "0.5";
export const commandListSizeHeight = "320px";
export const commandEmptySpacePaddingY = "16px";
export const commandEmptyFontSize = "14px";
export const commandEmptyLineHeight = "20px";
export const commandGroupFontSizeHeading = "12px";
export const commandGroupLineHeightHeading = "16px";
export const commandGroupFontWeightHeading = "500";
export const commandGroupColorTextDefault = "#262626";
export const commandGroupColorTextHeading = "#737373";
export const commandGroupSpacePadding = "4px";
export const commandGroupSpacePaddingYHeading = "6px";
export const commandGroupSpacePaddingXHeading = "8px";
export const commandSeparatorColor = "#d4d4d4";
export const commandSeparatorSizeHeight = "1px";
export const commandSeparatorSpaceMarginX = "4px";
export const commandItemFontSize = "14px";
export const commandItemLineHeight = "20px";
export const commandItemSpacePaddingX = "8px";
export const commandItemSpacePaddingY = "6px";
export const commandItemRadius = "8px";
export const commandItemColorBackgroundSelected = "#e5e5e5";
export const commandItemColorTextSelected = "#0a0a0a";
export const commandItemOpacityDisabled = "0.5";
export const commandShortcutColorText = "#737373";
export const commandShortcutFontSize = "12px";
export const commandShortcutLineHeight = "16px";
export const commandShortcutTracking = "0.1em";
export const datePickerColorPlaceholder = "#737373";
export const datePickerFontWeight = "400";
export const datePickerFontSize = "14px";
export const datePickerSpacePaddingL = "12px";
export const datePickerSpacePaddingR = "12px";
export const datePickerActionHeight = "240px";
export const datePickerActionSpacePaddingL = "12px";
export const datePickerActionSpacePaddingR = "12px";
export const datePickerSizeWidth = "240px";
export const datePickerIconSize = "16px";
export const datePickerIconOpacity = "0.5";
export const datePickerPopoverSpacePadding = "0px";
export const dialogOverlayColorBackground = "#000000";
export const dialogOverlayOpacityBackground = "0.8";
export const dialogContentColorBackground = "#ffffff";
export const dialogContentShadow =
  "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)";
export const dialogContentSpaceGap = "16px";
export const dialogContentSpacePadding = "24px";
export const dialogContentRadius = "4px";
export const dialogContentBorderWidth = "1px";
export const dialogHeaderSpaceMarginY = "6px";
export const dialogFooterSpaceMarginX = "8px";
export const dialogTitleSize = "18px";
export const dialogTitleColor = "#0058a9";
export const dialogTitleFontWeight = "600";
export const dialogTitleLineHeight = "1";
export const dialogTitleLetterSpacing = "-0.025em";
export const dialogDescriptionColor = "#737373";
export const dialogDescriptionSize = "14px";
export const dialogDescriptionLineHeight = "20px";
export const dialogCloseSizeIcon = "20px";
export const dialogCloseColorBackground = "#ffffff";
export const dialogCloseColorIcon = "#737373";
export const dialogClosePositionRight = "12px";
export const dialogClosePositionTop = "12px";
export const dialogCloseOpacityDefault = "0.7";
export const dialogCloseOpacityHover = "1";
export const dialogCloseRadius = "4px";
export const dialogCloseRingColorOffset = "#ffffff";
export const dialogCloseRingFocusOffset = "8px";
export const dialogCloseRingFocusWidth = "2px";
export const drawerOverlayColorBackground = "#000000";
export const drawerOverlayOpacityBackground = "0.8";
export const drawerContentColorBackground = "#ffffff";
export const drawerContentSpaceMarginTop = "96px";
export const drawerContentBorder = "1px";
export const drawerContentRadiusTop = "4px";
export const drawerContentHandleColorBackground = "#f5f5f5";
export const drawerContentHandleSpaceMarginTop = "16px";
export const drawerContentHandleRadius = "8px";
export const drawerContentHandleSizeHeight = "8px";
export const drawerContentHandleSizeWidth = "96px";
export const drawerHeaderSpaceGap = "6px";
export const drawerHeaderSpacePadding = "16px";
export const drawerFooterSpaceGap = "8px";
export const drawerFooterSpacePadding = "16px";
export const drawerTitleColor = "#262626";
export const drawerTitleFontSize = "18px";
export const drawerTitleLineHeight = "1";
export const drawerTitleLetterSpacing = "-0.025em";
export const drawerTitleFontWeight = "600";
export const drawerDescriptionColor = "#737373";
export const drawerDescriptionFontSize = "14px";
export const drawerDescriptionLineHeight = "20px";
export const dropdownMenuContentColorBackground = "#ffffff";
export const dropdownMenuContentColorText = "#262626";
export const dropdownMenuContentColorBorder = "#d4d4d4";
export const dropdownMenuContentRadius = "4px";
export const dropdownMenuContentBorder = "1px";
export const dropdownMenuContentShadow =
  "rgba(0, 0, 0, 0.02) 0px 4px 4px -1px, rgba(0, 0, 0, 0.06) 0px 1px 1px 0px";
export const dropdownMenuContentSpacingPadding = "4px";
export const dropdownMenuSubContentColorBackground = "#ffffff";
export const dropdownMenuSubContentColorText = "#262626";
export const dropdownMenuSubContentColorBorder = "#d4d4d4";
export const dropdownMenuSubContentRadius = "4px";
export const dropdownMenuSubContentBorder = "1px";
export const dropdownMenuSubContentSpacingPadding = "4px";
export const dropdownMenuSubContentShadow =
  "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)";
export const dropdownMenuMenuItemColorBackgroundFocus = "#f5f5f5";
export const dropdownMenuMenuItemColorBackgroundTextFocus = "#262626";
export const dropdownMenuMenuItemFontSize = "14px";
export const dropdownMenuMenuItemRadius = "4px";
export const dropdownMenuMenuItemSpacingGap = "8px";
export const dropdownMenuMenuItemSpacingPaddingX = "8px";
export const dropdownMenuMenuItemSpacingPaddingY = "6px";
export const dropdownMenuMenuItemSpacingPaddingInset = "32px";
export const dropdownMenuSubTriggerColorBackgroundFocus = "#f5f5f5";
export const dropdownMenuSubTriggerColorBackgroundTextFocus = "#262626";
export const dropdownMenuSubTriggerFontSize = "14px";
export const dropdownMenuSubTriggerRadius = "4px";
export const dropdownMenuSubTriggerSpacingGap = "8px";
export const dropdownMenuSubTriggerSpacingPaddingX = "8px";
export const dropdownMenuSubTriggerSpacingPaddingY = "6px";
export const dropdownMenuSubTriggerSpacingPaddingInset = "32px";
export const dropdownMenuCheckboxItemColorBackgroundFocus = "#f5f5f5";
export const dropdownMenuCheckboxItemColorBackgroundTextFocus = "#262626";
export const dropdownMenuCheckboxItemFontSize = "14px";
export const dropdownMenuCheckboxItemRadius = "4px";
export const dropdownMenuCheckboxItemSpacingPaddingL = "32px";
export const dropdownMenuCheckboxItemSpacingPaddingR = "8px";
export const dropdownMenuCheckboxItemSpacingPaddingY = "6px";
export const dropdownMenuCheckboxItemSpacingPaddingInset = "32px";
export const dropdownMenuCheckboxItemIndicatorPositionLeft = "8px";
export const dropdownMenuCheckboxItemIndicatorSize = "14px";
export const dropdownMenuCheckboxItemIndicatorIconSize = "16px";
export const dropdownMenuRadioItemColorBackgroundFocus = "#f5f5f5";
export const dropdownMenuRadioItemColorBackgroundTextFocus = "#262626";
export const dropdownMenuRadioItemFontSize = "14px";
export const dropdownMenuRadioItemRadius = "4px";
export const dropdownMenuRadioItemSpacingPaddingL = "32px";
export const dropdownMenuRadioItemSpacingPaddingR = "8px";
export const dropdownMenuRadioItemSpacingPaddingY = "6px";
export const dropdownMenuRadioItemSpacingPaddingInset = "32px";
export const dropdownMenuRadioItemIndicatorPositionLeft = "8px";
export const dropdownMenuRadioItemIndicatorSize = "14px";
export const dropdownMenuRadioItemIndicatorIconSize = "16px";
export const dropdownMenuLabelFontSize = "14px";
export const dropdownMenuLabelFontWeight = "600";
export const dropdownMenuLabelSpacingPaddingX = "8px";
export const dropdownMenuLabelSpacingPaddingY = "6px";
export const dropdownMenuLabelSpacingPaddingInset = "32px";
export const dropdownMenuSeparatorColorBackground = "#f5f5f5";
export const dropdownMenuSeparatorSizeHeight = "1px";
export const dropdownMenuSeparatorSpacingMarginX = "4px";
export const dropdownMenuSeparatorSpacingMarginY = "4px";
export const dropdownMenuShortcutFontSize = "12px";
export const dropdownMenuShortcutOpacity = "0.6";
export const formItemSpaceMarginY = "8px";
export const formDescriptionFontSize = "14px";
export const formDescriptionLineHeight = "20px";
export const formMessageFontSize = "14px";
export const formMessageLineHeight = "20px";
export const formMessageFontWeight = "500";
export const trinketIconGrade = -25;
export const trinketIconStyleFill = 0;
export const trinketIconStyleRounded = 1;
export const inputColorBackgroundDefault = "#ffffff";
export const inputColorBackgroundFile = "rgba(0, 0, 0, 0)";
export const inputColorRingRing = "#015094";
export const inputColorRingOffsetBackground = "#ffffff";
export const inputColorBorderDefault = "#d4d4d4";
export const inputColorBorderDanger = "#dc2626";
export const inputColorTextPlaceholder = "#737373";
export const inputBorderDefault = "1px";
export const inputBorderFile = "0px";
export const inputRingFocusWidth = "2px";
export const inputRingFocusOffset = "2px";
export const inputFontSize = "14px";
export const inputLineHeight = "20px";
export const inputFontWeightFile = "500";
export const inputRadius = "4px";
export const inputSizeHeight = "40px";
export const inputSpacePaddingX = "12px";
export const inputSpacePaddingY = "8px";
export const inputSpacePaddingL = "40px";
export const inputSpacePaddingR = "40px";
export const inputOpacityDisabled = "0.5";
export const inputAdornmentFontSize = "14px";
export const inputAdornmentColor = "#737373";
export const inputAdornmentSpacePaddingL = "12px";
export const inputAdornmentSpacePaddingR = "12px";
export const labelFontSize = "14px";
export const labelFontWeight = "500";
export const labelFontFamily = ["Inter Variable", "sans-serif"];
export const labelLineHeight = "1";
export const labelDisabledOpacity = "0.7";
export const linkColorDefault = "#015094";
export const linkColorHover = "#006fd0";
export const linkFontSize = "16px";
export const linkLineHeight = "24px";
export const linkFontWeight = "500";
export const navbarColorBackgroundDefault = "#ffffff";
export const navbarColorBorder = "#d4d4d4";
export const navbarSizeHeight = "56px";
export const navbarSizeWidth = "100%";
export const navbarSizeMaxWidth = "1536px";
export const navigationMenuListSpaceMarginX = "4px";
export const navigationMenuTriggerColorBackgroundDefault = "#ffffff";
export const navigationMenuTriggerColorBackgroundHover = "#f5f5f5";
export const navigationMenuTriggerColorBackgroundFocus = "#f5f5f5";
export const navigationMenuTriggerColorBackgroundActive = "#f5f5f5";
export const navigationMenuTriggerColorBackgroundOpen = "#f5f5f5";
export const navigationMenuTriggerColorTextDefault = "#262626";
export const navigationMenuTriggerColorTextHover = "#262626";
export const navigationMenuTriggerColorTextFocus = "#262626";
export const navigationMenuTriggerFontSize = "14px";
export const navigationMenuTriggerFontWeight = "500";
export const navigationMenuTriggerLineHeight = "20px";
export const navigationMenuTriggerSpacePaddingX = "16px";
export const navigationMenuTriggerSpacePaddingY = "8px";
export const navigationMenuTriggerSizeHeight = "40px";
export const navigationMenuTriggerOpacityDisabled = "0.5";
export const navigationMenuTriggerRadius = "8px";
export const navigationMenuTriggerIconPositionTop = "1px";
export const navigationMenuTriggerIconSize = "12px";
export const navigationMenuTriggerIconSpaceMarginL = "4px";
export const navigationMenuContentPositionTop = "0px";
export const navigationMenuContentPositionLeft = "0px";
export const navigationMenuContentSizeWidth = "100%";
export const navigationMenuViewportColorBackground = "#ffffff";
export const navigationMenuViewportColorText = "#262626";
export const navigationMenuViewportRadius = "4px";
export const navigationMenuViewportBorder = "1px";
export const navigationMenuViewportPositionLeft = "0px";
export const navigationMenuViewportSizeWidth = "100%";
export const navigationMenuViewportSpaceMarginT = "6px";
export const navigationMenuViewportShadow =
  "rgba(0, 0, 0, 0.02) 0px 4px 4px -1px, rgba(0, 0, 0, 0.06) 0px 1px 1px 0px";
export const navigationMenuIndicatorColorBackground = "#d4d4d4";
export const navigationMenuIndicatorSizeHeight = "6px";
export const navigationMenuIndicatorBorderSize = "8px";
export const navigationMenuIndicatorRadius = "8px";
export const navigationMenuIndicatorShadow =
  "rgba(0, 0, 0, 0.02) 0px 4px 4px -1px, rgba(0, 0, 0, 0.06) 0px 1px 1px 0px";
export const paginationSizeWidth = "100%";
export const paginationContentSpaceGap = "4px";
export const paginationPreviousGap = "4px";
export const paginationPreviousPaddingL = "10px";
export const paginationPreviousIconSize = "16px";
export const paginationNextSpaceGap = "4px";
export const paginationNextSpacePaddingR = "10px";
export const paginationNextIconSize = "16px";
export const paginationMoreSizeWidth = "36px";
export const paginationMoreSizeHeight = "36px";
export const paginationMoreSizeIconSize = "16px";
export const popoverColorBackground = "#ffffff";
export const popoverColorText = "#262626";
export const popoverColorBorder = "#d4d4d4";
export const popoverRadius = "4px";
export const popoverBorder = "1px";
export const popoverShadow =
  "rgba(0, 0, 0, 0.02) 0px 4px 4px -1px, rgba(0, 0, 0, 0.06) 0px 1px 1px 0px";
export const popoverSizeWidth = "288px";
export const popoverSpacePadding = "16px";
export const radioGroupColorRingRing = "#015094";
export const radioGroupColorRingOffsetBackground = "#ffffff";
export const radioGroupColorBorderDefault = "#d4d4d4";
export const radioGroupColorTextDefault = "#262626";
export const radioGroupBorderDefault = "1px";
export const radioGroupRadius = "9999px";
export const radioGroupRingFocusWidth = "2px";
export const radioGroupRingFocusOffset = "2px";
export const radioGroupSizeHeight = "16px";
export const radioGroupSizeWidth = "16px";
export const radioGroupOpacityDisabled = "0.5";
export const radioGroupIconSize = "10px";
export const scrollAreaSizeWidth = "100%";
export const scrollAreaSizeHeight = "100%";
export const scrollAreaScrollBarColorBorder = "rgba(0, 0, 0, 0)";
export const scrollAreaScrollBarSizeVerticalWidth = "10px";
export const scrollAreaScrollBarSizeVerticalHeight = "100%";
export const scrollAreaScrollBarSizeHorizontalWidth = "100%";
export const scrollAreaScrollBarSizeHorizontalHeight = "10px";
export const scrollAreaScrollBarBorderLeft = "1px";
export const scrollAreaScrollBarBorderTop = "1px";
export const scrollAreaScrollBarSpacePadding = "1px";
export const scrollAreaThumbColorBackground = "#d4d4d4";
export const scrollAreaThumbRadius = "9999px";
export const selectTriggerColorBackground = "#ffffff";
export const selectTriggerColorBorder = "#d4d4d4";
export const selectTriggerColorRingRing = "#015094";
export const selectTriggerColorRingOffsetBackground = "#ffffff";
export const selectTriggerColorTextPlaceholder = "#737373";
export const selectTriggerBorder = "1px";
export const selectTriggerFontSize = "14px";
export const selectTriggerLineHeight = "20px";
export const selectTriggerRadius = "4px";
export const selectTriggerSizeHeight = "40px";
export const selectTriggerRingFocusWidth = "2px";
export const selectTriggerRingFocusOffset = "2px";
export const selectTriggerSpacePaddingX = "12px";
export const selectTriggerSpacePaddingY = "8px";
export const selectTriggerOpacityDisabled = "0.5";
export const selectTriggerIconSize = "16px";
export const selectTriggerIconOpacity = "0.5";
export const selectScrollUpDownButtonSpacePaddingY = "4px";
export const selectScrollUpDownButtonIconSize = "16px";
export const selectContentColorBackground = "#ffffff";
export const selectContentColorText = "#262626";
export const selectContentRadius = "4px";
export const selectContentBorder = "1px";
export const selectContentShadow =
  "rgba(0, 0, 0, 0.02) 0px 4px 4px -1px, rgba(0, 0, 0, 0.06) 0px 1px 1px 0px";
export const selectLabelFontSize = "14px";
export const selectLabelLineHeight = "20px";
export const selectLabelFontWeight = "600";
export const selectLabelSpacePaddingY = "6px";
export const selectLabelSpacePaddingL = "32px";
export const selectLabelSpacePaddingR = "8px";
export const selectItemColorBackgroundFocus = "#f5f5f5";
export const selectItemColorTextFocus = "#262626";
export const selectItemRadius = "4px";
export const selectItemFontSize = "14px";
export const selectItemLineHeight = "20px";
export const selectItemSpacePaddingY = "4px";
export const selectItemSpacePaddingL = "32px";
export const selectItemSpacePaddingR = "8px";
export const selectItemOpacityDisabled = "0.5";
export const selectItemIndicatorSize = "16px";
export const selectItemIndicatorPositionTop = "8px";
export const selectItemIndicatorPositionLeft = "8px";
export const selectItemIndicatorIconSize = "16px";
export const selectSeperatorColorBackground = "#f5f5f5";
export const selectSeperatorSizeHeight = "1px";
export const selectSeperatorSpaceMarginX = "4px";
export const selectSeperatorSpaceMarginY = "4px";
export const separatorColorBackground = "#d4d4d4";
export const separatorSizeHorizontalHeight = "1px";
export const separatorSizeHorizontalWidth = "100%";
export const separatorSizeVerticalHeight = "100%";
export const separatorSizeVerticalWidth = "1px";
export const sheetOverlayColorBackground = "#000000";
export const sheetOverlayOpacityBackground = "0.8";
export const sheetContentColorBackground = "#ffffff";
export const sheetContentSpaceGap = "16px";
export const sheetContentSpacePadding = "24px";
export const sheetContentShadow =
  "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)";
export const sheetContentBorderBottom = "1px";
export const sheetContentBorderLeft = "1px";
export const sheetContentBorderRight = "1px";
export const sheetContentBorderTop = "1px";
export const sheetContentSizeRightHeight = "100%";
export const sheetContentSizeRightWidth = "75%";
export const sheetContentSizeRightMaxWidth = "384px";
export const sheetContentSizeLeftHeight = "100%";
export const sheetContentSizeLeftWidth = "75%";
export const sheetContentSizeLeftMaxWidth = "384px";
export const sheetCloseSizeIcon = "16px";
export const sheetCloseColorBackground = "#ffffff";
export const sheetCloseColorIcon = "#737373";
export const sheetClosePositionRight = "16px";
export const sheetClosePositionTop = "16px";
export const sheetCloseOpacityDefault = "0.7";
export const sheetCloseOpacityHover = "1";
export const sheetCloseRadius = "4px";
export const sheetCloseRingColorOffset = "#ffffff";
export const sheetCloseRingFocusOffset = "8px";
export const sheetCloseRingFocusWidth = "2px";
export const sheetHeaderSpaceMarginY = "8px";
export const sheetFooterSpaceMarginX = "8px";
export const sheetTitleColor = "#262626";
export const sheetTitleFontSize = "18px";
export const sheetTitleLineHeight = "28px";
export const sheetTitleFontWeight = "600";
export const sheetDescriptionColor = "#737373";
export const sheetDescriptionFontSize = "14px";
export const sheetDescriptionLineHeight = "20px";
export const sidebarBackground = "#fafafa";
export const sidebarForeground = "#404040";
export const sidebarPrimary = "#171717";
export const sidebarPrimaryForeground = "#fafafa";
export const sidebarAccent = "#e5e5e5";
export const sidebarAccentForeground = "#171717";
export const sidebarBorder = "#e5e5e5";
export const sidebarRing = "#038ef4";
export const skeletonColorBackground = "#f5f5f5";
export const skeletonRadius = "4px";
export const switchBgDefault = "#e5e5e5";
export const switchBgChecked = "#015094";
export const switchThumb = "#ffffff";
export const tableFontSize = "14px";
export const tableLineHeight = "20px";
export const tableSizeWidth = "100%";
export const tableHeaderBorderBottom = "1px";
export const tableBodyBorder = "0px";
export const tableFooterColorBackground = "#f5f5f5";
export const tableFooterOpacityBackground = "0.5";
export const tableFooterFontWeight = "500";
export const tableFooterBorderTop = "1px";
export const tableFooterBorderBottom = "0px";
export const tableRowColorBackgroundHover = "#f5f5f5";
export const tableRowColorBackgroundSelected = "#f5f5f5";
export const tableRowOpacityBackgroundHover = "0.5";
export const tableRowBorderB = "1px";
export const tableHeadFontWeight = "500";
export const tableHeadColorText = "#737373";
export const tableHeadSizeHeight = "48px";
export const tableHeadSpacePaddingX = "16px";
export const tableHeadSpacePaddingR = "0px";
export const tableCellSpacePadding = "16px";
export const tableCellSpacePaddingR = "0px";
export const tableCaptionFontSize = "14px";
export const tableCaptionLineHeight = "20px";
export const tableCaptionColor = "#737373";
export const tableCaptionSpaceMarginT = "16px";
export const tabsListColorBackground = "#f5f5f5";
export const tabsListColorText = "#737373";
export const tabsListRadius = "8px";
export const tabsListSizeHeight = "40px";
export const tabsListSpacePadding = "4px";
export const tabsTriggerColorBackgroundActive = "#ffffff";
export const tabsTriggerColorBackgroundDefault = "#f5f5f5";
export const tabsTriggerColorTextActive = "#262626";
export const tabsTriggerColorTextDefault = "#737373";
export const tabsTriggerColorRingRing = "#015094";
export const tabsTriggerColorRingOffset = "#ffffff";
export const tabsTriggerRingWidth = "1px";
export const tabsTriggerRingFocusWidth = "2px";
export const tabsTriggerRingFocusOffset = "2px";
export const tabsTriggerFontSize = "14px";
export const tabsTriggerLineHeight = "20px";
export const tabsTriggerFontWeight = "500";
export const tabsTriggerSpacePaddingX = "12px";
export const tabsTriggerSpacePaddingY = "6px";
export const tabsTriggerOpacityDisabled = "0.5";
export const tabsTriggerShadowActive = "none";
export const tabsTriggerRadius = "4px";
export const tabsContentColorRingRing = "#015094";
export const tabsContentColorRingOffset = "#ffffff";
export const tabsContentSpaceMarginT = "8px";
export const tabsContentRingWidth = "1px";
export const tabsContentRingFocusWidth = "2px";
export const tabsContentRingFocusOffset = "2px";
export const textareaColorBackgroundDefault = "#ffffff";
export const textareaColorRingRing = "#015094";
export const textareaColorRingOffsetBackground = "#ffffff";
export const textareaColorBorder = "#d4d4d4";
export const textareaColorTextPlaceholder = "#737373";
export const textareaBorderDefault = "1px";
export const textareaRingFocusWidth = "2px";
export const textareaRingFocusOffset = "2px";
export const textareaFontSize = "14px";
export const textareaLineHeight = "20px";
export const textareaFontWeightFile = "500";
export const textareaRadius = "4px";
export const textareaSpacePaddingX = "12px";
export const textareaSpacePaddingY = "8px";
export const textareaSpacePaddingL = "40px";
export const textareaSpacePaddingR = "40px";
export const textareaOpacityDisabled = "0.5";
export const toastColorBackgroundDefault = "#ffffff";
export const toastColorBackgroundDestructive = "#dc2626";
export const toastColorBackgroundSuccess = "#16a34a";
export const toastColorTextDefault = "#262626";
export const toastColorTextDestructive = "#fafafa";
export const toastColorTextSuccess = "#fafafa";
export const toastColorBorderDestructive = "#dc2626";
export const toastColorBorderSuccess = "#16a34a";
export const toastSpaceMarginX = "16px";
export const toastSpacePadding = "24px";
export const toastSpacePaddingR = "32px";
export const toastRadius = "4px";
export const toastShadow =
  "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)";
export const toastBorderWidthDefault = "1px";
export const toastViewportSpacePadding = "16px";
export const toastViewportPositionTop = "0px";
export const toastViewportPositionRight = "0px";
export const toastViewportPositionBottom = "0px";
export const toastActionSpacePaddingX = "12px";
export const toastActionRadius = "4px";
export const toastActionSizeHeight = "32px";
export const toastActionColorRingOffset = "#ffffff";
export const toastActionColorBackgroundDefault = "rgba(0, 0, 0, 0)";
export const toastActionColorBackgroundHoverDefault = "#f5f5f5";
export const toastActionColorBackgroundHoverDestructive = "#dc2626";
export const toastActionColorBackgroundHoverSuccess = "#16a34a";
export const toastActionColorBorderDestructiveDefault = "#a3a3a3";
export const toastActionColorBorderDestructiveHover = "#dc2626";
export const toastActionColorBorderSuccessDefault = "#a3a3a3";
export const toastActionColorBorderSuccessHover = "#dc2626";
export const toastActionColorTextDefault = "#262626";
export const toastActionColorTextHover = "#262626";
export const toastActionColorTextSuccessDefault = "#262626";
export const toastActionColorTextSuccessHover = "#262626";
export const toastActionColorTextDestructiveDefault = "#fafafa";
export const toastActionColorTextDestructiveHover = "#fafafa";
export const toastActionRingWidth = "2px";
export const toastActionRingOffset = "2px";
export const toastActionTextFontSize = "14px";
export const toastActionTextFontWeight = "500";
export const toastActionOpacityDisabled = "0.5";
export const toastCloseColorTextDefault = "#262626";
export const toastCloseColorTextDestructive = "#fafafa";
export const toastCloseColorTextHoverDefault = "#262626";
export const toastCloseColorTextHoverDestructive = "#fafafa";
export const toastCloseColorRingDestructive = "#dc2626";
export const toastCloseColorRingOffset = "rgba(0, 0, 0, 0)";
export const toastCloseSpacePadding = "4px";
export const toastClosePositionTop = "8px";
export const toastClosePositionRight = "8px";
export const toastCloseRadius = "4px";
export const toastCloseOpacityDefault = "0";
export const toastCloseOpacityHover = "1";
export const toastCloseRingWidth = "2px";
export const toastCloseSizeIcon = "18px";
export const toastTitleFontFamily = ["Inter Variable", "sans-serif"];
export const toastTitleFontSize = "14px";
export const toastTitleFontWeight = "600";
export const toastTitleLineHeight = "20px";
export const toastDescriptionFontSize = "14px";
export const toastDescriptionLineHeight = "20px";
export const toastDescriptionOpacity = "0.9";
export const tooltipColorBackground = "#ffffff";
export const tooltipColorText = "#262626";
export const tooltipRadius = "4px";
export const tooltipBorder = "1px";
export const tooltipFontSize = "14px";
export const tooltipLineHeight = "20px";
export const tooltipShadow =
  "rgba(0, 0, 0, 0.02) 0px 4px 4px -1px, rgba(0, 0, 0, 0.06) 0px 1px 1px 0px";
export const tooltipSpacePaddingX = "12px";
export const tooltipSpacePaddingY = "6px";
export const typographyH1FontFamily = ["Inter Variable", "sans-serif"];
export const typographyH1FontSize = "36px";
export const typographyH1LineHeight = "40px";
export const typographyH1FontWeight = "800";
export const typographyH1LetterSpacing = "-0.025em";
export const typographyH2FontFamily = ["Inter Variable", "sans-serif"];
export const typographyH2FontSize = "30px";
export const typographyH2LineHeight = "36px";
export const typographyH2FontWeight = "600";
export const typographyH2LetterSpacing = "-0.025em";
export const typographyH3FontFamily = ["Inter Variable", "sans-serif"];
export const typographyH3FontSize = "24px";
export const typographyH3LineHeight = "32px";
export const typographyH3FontWeight = "600";
export const typographyH3LetterSpacing = "-0.025em";
export const typographyH4FontFamily = ["Inter Variable", "sans-serif"];
export const typographyH4FontSize = "20px";
export const typographyH4LineHeight = "28px";
export const typographyH4FontWeight = "600";
export const typographyH4LetterSpacing = "-0.025em";
export const typographyH5FontFamily = ["Inter Variable", "sans-serif"];
export const typographyH5FontSize = "18px";
export const typographyH5LineHeight = "28px";
export const typographyH5FontWeight = "600";
export const typographyH5LetterSpacing = "-0.025em";
export const typographyH6FontFamily = ["Inter Variable", "sans-serif"];
export const typographyH6FontSize = "16px";
export const typographyH6LineHeight = "24px";
export const typographyH6FontWeight = "600";
export const typographyH6LetterSpacing = "-0.025em";
export const typographyBodyLgFontFamily = ["Inter Variable", "sans-serif"];
export const typographyBodyLgFontSize = "18px";
export const typographyBodyLgLineHeight = "28px";
export const typographyBodyLgFontWeight = "400";
export const typographyBodyMdFontFamily = ["Inter Variable", "sans-serif"];
export const typographyBodyMdFontSize = "16px";
export const typographyBodyMdLineHeight = "24px";
export const typographyBodyMdFontWeight = "400";
export const typographyBodySmFontFamily = ["Inter Variable", "sans-serif"];
export const typographyBodySmFontSize = "14px";
export const typographyBodySmLineHeight = "1";
export const typographyBodySmFontWeight = "400";
export const typographyLeadFontFamily = ["Inter Variable", "sans-serif"];
export const typographyLeadFontSize = "20px";
export const typographyLeadLineHeight = "28px";
export const typographyLeadFontWeight = "500";
export const typographySubtitleFontFamily = ["Inter Variable", "sans-serif"];
export const typographySubtitleFontSize = "20px";
export const typographySubtitleLineHeight = "28px";
export const typographySubtitleFontWeight = "500";
export const typographyCaptionFontFamily = ["Inter Variable", "sans-serif"];
export const typographyCaptionFontSize = "14px";
export const typographyCaptionLineHeight = "1";
export const typographyCaptionFontWeight = "500";
export const typographyEyebrowFontFamily = ["Inter Variable", "sans-serif"];
export const typographyEyebrowFontSize = "16px";
export const typographyEyebrowLineHeight = "24px";
export const typographyEyebrowFontWeight = "500";
export const animationNormal =
  "color 0.2s cubic-bezier(0.22, 1, 0.36, 1), background-color 0.2s cubic-bezier(0.22, 1, 0.36, 1), border-color 0.2s cubic-bezier(0.22, 1, 0.36, 1)";
export const animationAll = "all 0.2s cubic-bezier(0.22, 1, 0.36, 1)";
export const animationTransform =
  "transform 0.2s cubic-bezier(0.22, 1, 0.36, 1)";
export const borderRadiusSm = "4px";
export const borderRadiusMd = "8px";
export const borderRadiusLg = "16px";
export const borderRadiusFull = "9999px";
export const borderRadiusAction = "8px";
export const borderRadiusInput = "4px";
export const borderRadiusDefault = "4px";
export const borderWidthNone = "0px";
export const borderWidthMd = "1px";
export const borderWidthLg = "2px";
export const borderWidthDefault = "1px";
export const borderWidthAction = "1px";
export const borderWidthOutline = "1px";
export const borderWidthForm = "1px";
export const borderWidthInput = "1px";
export const borderWidthFocus = "2px";
export const colorBlue50 = "#eff6ff";
export const colorBlue100 = "#dbeafe";
export const colorBlue200 = "#bfdbfe";
export const colorBlue300 = "#93c5fd";
export const colorBlue400 = "#60a5fa";
export const colorBlue500 = "#3b82f6";
export const colorBlue600 = "#2563eb";
export const colorBlue700 = "#1d4ed8";
export const colorBlue800 = "#1e40af";
export const colorBlue900 = "#1e3a8a";
export const colorBlue950 = "#172554";
export const colorAmber50 = "#fffbeb";
export const colorAmber100 = "#fef3c7";
export const colorAmber200 = "#fde68a";
export const colorAmber300 = "#fcd34d";
export const colorAmber400 = "#fbbf24";
export const colorAmber500 = "#f59e0b";
export const colorAmber600 = "#d97706";
export const colorAmber700 = "#b45309";
export const colorAmber800 = "#92400e";
export const colorAmber900 = "#78350f";
export const colorAmber950 = "#451a03";
export const colorBrand50 = "#eff7ff";
export const colorBrand100 = "#dfeeff";
export const colorBrand200 = "#b7dfff";
export const colorBrand300 = "#77c6ff";
export const colorBrand400 = "#2fa9ff";
export const colorBrand500 = "#038ef4";
export const colorBrand600 = "#006fd0";
export const colorBrand700 = "#0058a9";
export const colorBrand800 = "#015094";
export const colorBrand900 = "#073f73";
export const colorBrand950 = "#05284c";
export const colorNeutral50 = "#fafafa";
export const colorNeutral100 = "#f5f5f5";
export const colorNeutral200 = "#e5e5e5";
export const colorNeutral300 = "#d4d4d4";
export const colorNeutral400 = "#a3a3a3";
export const colorNeutral500 = "#737373";
export const colorNeutral600 = "#525252";
export const colorNeutral700 = "#404040";
export const colorNeutral800 = "#262626";
export const colorNeutral900 = "#171717";
export const colorNeutral950 = "#0a0a0a";
export const colorNeutralBlack = "#000000";
export const colorNeutralWhite = "#ffffff";
export const colorRed50 = "#fef2f2";
export const colorRed100 = "#fee2e2";
export const colorRed200 = "#fecaca";
export const colorRed300 = "#fca5a5";
export const colorRed400 = "#f87171";
export const colorRed500 = "#ef4444";
export const colorRed600 = "#dc2626";
export const colorRed700 = "#b91c1c";
export const colorRed800 = "#991b1b";
export const colorRed900 = "#7f1d1d";
export const colorRed950 = "#450a0a";
export const colorGreen50 = "#f0fdf4";
export const colorGreen100 = "#dcfce7";
export const colorGreen200 = "#bbf7d0";
export const colorGreen300 = "#86efac";
export const colorGreen400 = "#4ade80";
export const colorGreen500 = "#22c55e";
export const colorGreen600 = "#16a34a";
export const colorGreen700 = "#15803d";
export const colorGreen800 = "#166534";
export const colorGreen900 = "#14532d";
export const colorGreen950 = "#052e16";
export const colorTransparent = "rgba(0, 0, 0, 0)";
export const colorActionEnabled = "#015094";
export const colorActionHover = "#006fd0";
export const colorBackgroundNone = "rgba(0, 0, 0, 0)";
export const colorBackgroundSelected = "#e5e5e5";
export const colorBackgroundDefault = "#ffffff";
export const colorBackgroundHover = "#f5f5f5";
export const colorBackgroundMuted = "#f5f5f5";
export const colorBackgroundAction = "#015094";
export const colorBackgroundAccent = "#e5e5e5";
export const colorBackgroundPopover = "#ffffff";
export const colorBackgroundInfo = "#eff6ff";
export const colorBackgroundSuccess = "#f0fdf4";
export const colorBackgroundWarning = "#fffbeb";
export const colorBackgroundDanger = "#fef2f2";
export const colorBorderDefault = "#d4d4d4";
export const colorBorderMuted = "#a3a3a3";
export const colorBorderDanger = "#dc2626";
export const colorBorderInfo = "#bfdbfe";
export const colorBorderSuccess = "#bbf7d0";
export const colorBorderWarning = "#fde68a";
export const colorBorderDangerMuted = "#fecaca";
export const colorBorderInput = "#d4d4d4";
export const colorSuccessEnabled = "#16a34a";
export const colorSuccessHover = "#15803d";
export const colorDangerEnabled = "#dc2626";
export const colorDangerHover = "#b91c1c";
export const colorFocus = "#2563eb";
export const colorFormEnabled = "#015094";
export const colorFormHover = "#006fd0";
export const colorFormPlaceholder = "#737373";
export const colorTypographyAction = "#0a0a0a";
export const colorTypographyDanger = "#dc2626";
export const colorTypographyDefault = "#262626";
export const colorTypographyHeading = "#171717";
export const colorTypographyInverted = "#fafafa";
export const colorTypographyMuted = "#737373";
export const colorTypographyPrimary = "#015094";
export const colorTypographySecondary = "#525252";
export const colorTypographyInfo = "#1e3a8a";
export const colorTypographySuccess = "#14532d";
export const colorTypographyWarning = "#78350f";
export const colorTypographyDangerStrong = "#7f1d1d";
export const colorTypographyInfoAccent = "#1d4ed8";
export const colorTypographySuccessAccent = "#15803d";
export const colorTypographyWarningAccent = "#b45309";
export const colorTypographyDangerAccent = "#b91c1c";
export const fontFamilyBody = ["Inter Variable", "sans-serif"];
export const fontFamilyHeading = ["Inter Variable", "sans-serif"];
export const fontFamilyAction = ["Inter Variable", "sans-serif"];
export const fontSize0 = "12px";
export const fontSize1 = "14px";
export const fontSize2 = "16px";
export const fontSize3 = "18px";
export const fontSize4 = "20px";
export const fontSize5 = "24px";
export const fontSize6 = "30px";
export const fontSize7 = "36px";
export const fontSize8 = "48px";
export const fontSize9 = "60px";
export const fontSize10 = "72px";
export const fontSize11 = "96px";
export const fontSize12 = "128px";
export const fontWeightThin = "100";
export const fontWeightExtralight = "200";
export const fontWeightLight = "300";
export const fontWeightNormal = "400";
export const fontWeightMedium = "500";
export const fontWeightSemibold = "600";
export const fontWeightBold = "700";
export const fontWeightExtrabold = "800";
export const fontWeightBlack = "900";
export const fontWeightBase = "400";
export const fontWeightAction = "500";
export const iconsCircle = "material-symbols--circle";
export const iconsClose = "material-symbols--close";
export const iconsClear = "material-symbols--close";
export const iconsCalendar = "mdi--calendar";
export const iconsCheck = "material-symbols--check";
export const iconsChevronUp = "mdi--chevron-up";
export const iconsLogout = "material-symbols--logout";
export const iconsChevronDown = "mdi--chevron-down";
export const iconsChevronLeft = "material-symbols--chevron-left";
export const iconsChevronRight = "material-symbols--chevron-right";
export const iconsMenuClose = "material-symbols--arrow-menu-close-rounded";
export const iconsInfo = "material-symbols--info";
export const iconsSuccess = "material-symbols--check-circle";
export const iconsWarning = "material-symbols--warning";
export const iconsError = "material-symbols--error";
export const iconsSearch = "material-symbols--search";
export const iconsMore = "material-symbols--more-horiz";
export const iconsMenu = "material-symbols--menu";
export const iconsMail = "material-symbols--mail";
export const iconsPhone = "mdi--phone";
export const iconsLink = "material-symbols--external-link";
export const iconsArrowRight = "mdi--arrow-right";
export const iconsEdit = "mdi--edit-outline";
export const iconsDelete = "material-symbols--delete-outline";
export const iconsDashboard = "material-symbols--dashboard-outline";
export const iconsLoader = "line-md--loading-twotone-loop";
export const iconsLock = "material-symbols--lock-outline";
export const letterSpacingTighter = "-0.05em";
export const letterSpacingTight = "-0.025em";
export const letterSpacingNormal = "0em";
export const letterSpacingWide = "0.025em";
export const letterSpacingWider = "0.05em";
export const letterSpacingWidest = "0.1em";
export const lineHeight3 = "12px";
export const lineHeight4 = "16px";
export const lineHeight5 = "20px";
export const lineHeight6 = "24px";
export const lineHeight7 = "28px";
export const lineHeight8 = "32px";
export const lineHeight9 = "36px";
export const lineHeight10 = "40px";
export const lineHeightNone = "1";
export const lineHeightTight = "1.25";
export const lineHeightSnug = "1.375";
export const lineHeightNormal = "1.5";
export const lineHeightRelaxed = "1.75";
export const lineHeightLoose = "2";
export const opacity0 = "0";
export const opacity5 = "0.05";
export const opacity10 = "0.1";
export const opacity20 = "0.2";
export const opacity25 = "0.25";
export const opacity30 = "0.3";
export const opacity40 = "0.4";
export const opacity50 = "0.5";
export const opacity60 = "0.6";
export const opacity70 = "0.7";
export const opacity75 = "0.75";
export const opacity80 = "0.8";
export const opacity90 = "0.9";
export const opacity95 = "0.95";
export const opacity100 = "1";
export const opacityDefault = "1";
export const opacityDisabled = "0.5";
export const ringOffsetWidth0 = "0px";
export const ringOffsetWidth1 = "1px";
export const ringOffsetWidth2 = "2px";
export const ringOffsetWidth4 = "4px";
export const ringOffsetWidth8 = "8px";
export const ringOffsetWidthDefault = "1px";
export const ringOffsetWidthFocus = "2px";
export const ringWidth0 = "0px";
export const ringWidth1 = "1px";
export const ringWidth2 = "2px";
export const ringWidth4 = "4px";
export const ringWidth8 = "8px";
export const ringWidthRing = "3px";
export const ringWidthDefault = "1px";
export const ringWidthFocus = "2px";
export const shadowNone = "none";
export const shadowDefault =
  " 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)";
export const shadowSm = "0 1px 2px 0 rgb(0 0 0 / 0.05)";
export const shadowMd =
  "rgba(0, 0, 0, 0.02) 0px 4px 4px -1px, rgba(0, 0, 0, 0.06) 0px 1px 1px 0px";
export const shadowLg =
  "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)";
export const shadowXl =
  "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)";
export const shadow2xl = "0 25px 50px -12px rgb(0 0 0 / 0.25)";
export const shadowInner = " inset 0 2px 4px 0 rgb(0 0 0 / 0.05)";
export const shadowAction = "none";
export const shadowCard = "0 1px 2px 0 rgb(0 0 0 / 0.05)";
export const shadowDialog =
  "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)";
export const shadowToast =
  "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)";
export const shadowPopover =
  "rgba(0, 0, 0, 0.02) 0px 4px 4px -1px, rgba(0, 0, 0, 0.06) 0px 1px 1px 0px";
export const sizing0 = "0px";
export const sizing1 = "4px";
export const sizing2 = "8px";
export const sizing3 = "12px";
export const sizing4 = "16px";
export const sizing5 = "20px";
export const sizing6 = "24px";
export const sizing7 = "28px";
export const sizing8 = "32px";
export const sizing9 = "36px";
export const sizing10 = "40px";
export const sizing11 = "44px";
export const sizing12 = "48px";
export const sizing13 = "52px";
export const sizing14 = "56px";
export const sizing15 = "60px";
export const sizing16 = "64px";
export const sizing20 = "80px";
export const sizing24 = "96px";
export const sizing28 = "112px";
export const sizing32 = "128px";
export const sizing36 = "144px";
export const sizing40 = "160px";
export const sizing44 = "176px";
export const sizing48 = "192px";
export const sizing52 = "208px";
export const sizing56 = "224px";
export const sizing60 = "240px";
export const sizing64 = "256px";
export const sizing72 = "288px";
export const sizing80 = "320px";
export const sizing96 = "384px";
export const sizingPx = "1px";
export const sizing0p5 = "2px";
export const sizing1p5 = "6px";
export const sizing2p5 = "10px";
export const sizing3p5 = "14px";
export const sizing4p5 = "18px";
export const sizingW14 = "25%";
export const sizingW24 = "50%";
export const sizingW34 = "75%";
export const sizingFull = "100%";
export const sizingScreenSm = "640px";
export const sizingScreenMd = "768px";
export const sizingScreenLg = "1024px";
export const sizingScreenXl = "1280px";
export const sizingScreen2xl = "1536px";
export const spacing0 = "0px";
export const spacing1 = "4px";
export const spacing2 = "8px";
export const spacing3 = "12px";
export const spacing4 = "16px";
export const spacing5 = "20px";
export const spacing6 = "24px";
export const spacing7 = "28px";
export const spacing8 = "32px";
export const spacing9 = "36px";
export const spacing10 = "40px";
export const spacing11 = "44px";
export const spacing12 = "48px";
export const spacing13 = "52px";
export const spacing14 = "56px";
export const spacing15 = "60px";
export const spacing16 = "64px";
export const spacing20 = "80px";
export const spacing24 = "96px";
export const spacing28 = "112px";
export const spacing32 = "128px";
export const spacing36 = "144px";
export const spacing40 = "160px";
export const spacing44 = "176px";
export const spacing48 = "192px";
export const spacing52 = "208px";
export const spacing56 = "224px";
export const spacing60 = "240px";
export const spacing64 = "256px";
export const spacing72 = "288px";
export const spacing80 = "320px";
export const spacing96 = "384px";
export const spacingPx = "1px";
export const spacing0p5 = "2px";
export const spacing1p5 = "6px";
export const spacing2p5 = "10px";
export const spacing3p5 = "14px";
export const spacing4p5 = "18px";
export const overlayDefaultColorBackground = "#000000";
export const overlayDefaultOpacityBackground = "0.8";
export const textBaseFontSize = "16px";
export const textBaseLineHeight = "24px";
export const textXsFontSize = "12px";
export const textXsLineHeight = "16px";
export const textSmFontSize = "14px";
export const textSmLineHeight = "20px";
export const textLgFontSize = "18px";
export const textLgLineHeight = "28px";
export const textXlFontSize = "20px";
export const textXlLineHeight = "28px";
export const text2xlFontSize = "24px";
export const text2xlLineHeight = "32px";
export const text3xlFontSize = "30px";
export const text3xlLineHeight = "36px";
export const text4xlFontSize = "36px";
export const text4xlLineHeight = "40px";
export const text5xlFontSize = "48px";
export const text6xlFontSize = "60px";
export const text7xlFontSize = "72px";
export const text8xlFontSize = "96px";
export const text9xlFontSize = "128px";
export const transitionDefault =
  "color 0.2s cubic-bezier(0.22, 1, 0.36, 1), background-color 0.2s cubic-bezier(0.22, 1, 0.36, 1), border-color 0.2s cubic-bezier(0.22, 1, 0.36, 1)";
